var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChedrauiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_Layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 483.3 218.4",
    style: {
      enableBackground: "new 0 0 483.3 218.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0D47A1;}\r\n\t.st1{fill:#F76900;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#1F48A2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "BLUE_SHAPE",
    className: "st0",
    d: "M94.4,175V41c0-20,16.8-41,43.3-41h209.1c21.5,0,41.5,18.2,42,41.4v133.3 c0,17.7-12.2,43.7-43.7,43.7H136.3C118.2,218.4,94.4,203.8,94.4,175z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ORANGE_SHAPE",
    className: "st1",
    d: "M104.9,169.2v5.9c0,23,18.7,32.8,32.2,32.8h206.6c23,0,34.3-16.5,34.3-33.1v-5.5 L104.9,169.2L104.9,169.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WHITE_SHAPE",
    className: "st2",
    d: "M378.1,158.7V41.2c0-17.1-15.9-31-31.5-31H136.2C119,10.2,105,25.3,105,42.4v116.2 L378.1,158.7L378.1,158.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "CUESTA_MENOS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M142,190.4l6.1,0.7c-0.3,1.3-0.9,2.4-1.6,3.3c-0.8,0.9-1.7,1.6-2.9,2.1s-2.7,0.8-4.5,0.8s-3.2-0.2-4.4-0.5 c-1.2-0.3-2.2-0.9-3-1.6c-0.8-0.7-1.5-1.6-2-2.6s-0.7-2.3-0.7-3.9c0-1.7,0.3-3.1,0.9-4.3c0.4-0.8,1-1.6,1.8-2.2 c0.7-0.7,1.5-1.1,2.3-1.5c1.2-0.5,2.8-0.8,4.8-0.8c2.7,0,4.8,0.5,6.2,1.4c1.4,1,2.4,2.4,3,4.2l-6,0.8c-0.2-0.7-0.5-1.3-1-1.6 c-0.5-0.4-1.2-0.5-2-0.5c-1.1,0-1.9,0.4-2.6,1.1c-0.7,0.8-1,1.9-1,3.4c0,1.4,0.3,2.4,1,3.1c0.6,0.7,1.5,1.1,2.5,1.1 c0.8,0,1.5-0.2,2.1-0.6C141.3,191.9,141.7,191.2,142,190.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M166.8,196.8h-5.9v-2.7c-0.9,1.1-1.8,1.9-2.7,2.4c-0.9,0.5-2,0.7-3.3,0.7c-1.8,0-3.1-0.5-4.1-1.6 c-1-1-1.5-2.7-1.5-4.8v-10.6h6.4v9.1c0,1,0.2,1.8,0.6,2.2c0.4,0.4,0.9,0.7,1.6,0.7c0.8,0,1.4-0.3,1.9-0.9c0.5-0.6,0.7-1.6,0.7-3.1 v-8h6.3V196.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M174.7,187.1c0.1-1,0.4-1.7,0.7-2.2c0.6-0.8,1.4-1.2,2.4-1.2c0.9,0,1.6,0.3,2.1,0.8s0.9,1.4,1,2.6 L174.7,187.1L174.7,187.1z M187.5,189.4c0-2.2-0.4-4-1.1-5.3c-0.7-1.4-1.8-2.4-3.1-3.1c-1.4-0.7-3.3-1.1-5.6-1.1 c-2.9,0-5.2,0.8-6.9,2.4c-1.7,1.6-2.5,3.7-2.5,6.3c0,1.8,0.4,3.4,1.2,4.8c0.8,1.4,1.9,2.3,3.1,2.9c1.3,0.6,3,0.9,5.2,0.9 c2.5,0,4.5-0.4,5.8-1.1c1.4-0.7,2.5-1.9,3.5-3.6l-6.3-0.6c-0.4,0.5-0.8,0.9-1.1,1.1c-0.6,0.3-1.2,0.5-1.8,0.5 c-1,0-1.8-0.4-2.4-1.1c-0.4-0.5-0.7-1.3-0.8-2.3h12.8C187.5,190.1,187.5,189.4,187.5,189.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.6,192.2l6.3-0.6c0.3,0.7,0.6,1.3,1.1,1.6s1.1,0.5,1.9,0.5c0.9,0,1.5-0.2,2-0.5c0.4-0.3,0.5-0.6,0.5-1 c0-0.5-0.2-0.8-0.7-1.1c-0.3-0.2-1.3-0.4-2.7-0.7c-2.2-0.4-3.7-0.7-4.6-1.1c-0.9-0.3-1.6-0.9-2.2-1.7c-0.6-0.8-0.9-1.7-0.9-2.7 c0-1.1,0.3-2,1-2.8c0.6-0.8,1.5-1.4,2.6-1.8c1.1-0.4,2.6-0.6,4.5-0.6c2,0,3.4,0.2,4.4,0.5c0.9,0.3,1.7,0.8,2.4,1.4 c0.6,0.6,1.2,1.5,1.6,2.6l-6.1,0.6c-0.2-0.5-0.4-0.9-0.8-1.2c-0.5-0.3-1.1-0.5-1.8-0.5c-0.7,0-1.2,0.1-1.6,0.4 c-0.3,0.3-0.5,0.6-0.5,0.9c0,0.4,0.2,0.7,0.6,0.9c0.4,0.2,1.3,0.4,2.7,0.6c2.1,0.2,3.7,0.6,4.7,1s1.8,1,2.4,1.8 c0.5,0.8,0.8,1.7,0.8,2.6c0,1-0.3,1.9-0.9,2.8c-0.6,0.9-1.5,1.6-2.7,2.2c-1.2,0.5-2.9,0.8-5.1,0.8c-3,0-5.2-0.4-6.5-1.3 C188.8,195.1,188,193.8,187.6,192.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M214.3,173.9v6.3h3.5v4.6h-3.5v5.9c0,0.7,0.1,1.2,0.2,1.4c0.2,0.4,0.6,0.5,1.1,0.5s1.1-0.1,2-0.4l0.5,4.4 c-1.6,0.3-3,0.5-4.4,0.5c-1.6,0-2.8-0.2-3.5-0.6c-0.8-0.4-1.3-1-1.7-1.8c-0.4-0.8-0.5-2.2-0.5-4v-5.8h-2.4v-4.6h2.4v-3 L214.3,173.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M230.5,190c0,0.8-0.1,1.4-0.4,1.9c-0.3,0.5-0.7,0.9-1.3,1.3c-0.6,0.3-1.3,0.5-2,0.5s-1.2-0.2-1.5-0.5 s-0.5-0.7-0.5-1.2c0-0.4,0.2-0.8,0.5-1.2c0.3-0.3,1.2-0.7,2.4-1c0.9-0.2,1.8-0.5,2.7-0.8v1H230.5z M226,184.2 c0.5-0.3,1.3-0.5,2.3-0.5c0.8,0,1.4,0.2,1.7,0.5s0.5,0.9,0.5,1.6c-0.8,0.3-1.5,0.6-2.2,0.8s-2.3,0.5-4.6,1c-2,0.4-3.3,1-4.1,1.8 c-0.7,0.8-1.1,1.9-1.1,3.1c0,1.3,0.5,2.5,1.5,3.4s2.5,1.4,4.5,1.4c1.5,0,2.8-0.2,3.9-0.7c0.8-0.3,1.6-0.9,2.5-1.7 c0.1,0.5,0.1,0.8,0.2,1.1c0.1,0.2,0.2,0.5,0.5,1h6c-0.3-0.7-0.5-1.2-0.6-1.7c-0.1-0.4-0.1-1.1-0.1-1.8V186c0-0.8-0.2-1.6-0.5-2.5 s-0.7-1.5-1.3-2c-0.8-0.7-1.7-1.1-2.9-1.3s-2.7-0.3-4.6-0.3c-1.2,0-2.3,0.1-3.3,0.3s-1.8,0.4-2.4,0.8c-0.8,0.4-1.4,1-1.9,1.6 c-0.4,0.6-0.8,1.4-1,2.5l6.1,0.7C225.3,184.9,225.6,184.4,226,184.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M248,180.3h6v2.4c0.9-1,1.7-1.7,2.6-2.1c0.9-0.4,1.9-0.6,3.2-0.6c1.3,0,2.4,0.2,3.2,0.7s1.4,1.2,1.9,2.1 c1-1.1,1.9-1.8,2.7-2.2c0.8-0.4,1.8-0.6,3-0.6c1.8,0,3.2,0.5,4.2,1.6s1.5,2.7,1.5,5V197h-6.4v-9.5c0-0.8-0.1-1.3-0.4-1.7 c-0.4-0.6-1-0.9-1.6-0.9c-0.7,0-1.4,0.3-1.8,0.8c-0.5,0.5-0.7,1.4-0.7,2.6v8.6H259v-9.1c0-0.7,0-1.2-0.1-1.5 c-0.1-0.4-0.4-0.8-0.7-1c-0.3-0.3-0.7-0.4-1.2-0.4c-0.7,0-1.3,0.3-1.8,0.8c-0.5,0.6-0.7,1.5-0.7,2.7v8.5h-6.4v-16.6L248,180.3 L248,180.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M284,187.1c0.1-1,0.3-1.7,0.7-2.2c0.6-0.8,1.4-1.2,2.4-1.2c0.9,0,1.6,0.3,2.1,0.8s0.9,1.4,1,2.6L284,187.1 L284,187.1z M296.8,189.4c0-2.2-0.4-4-1.1-5.3c-0.7-1.4-1.8-2.4-3.1-3.1c-1.4-0.7-3.3-1.1-5.6-1.1c-2.9,0-5.2,0.8-6.9,2.4 c-1.7,1.6-2.5,3.7-2.5,6.3c0,1.8,0.4,3.4,1.2,4.8c0.8,1.4,1.9,2.3,3.1,2.9c1.3,0.6,3,0.9,5.2,0.9c2.5,0,4.5-0.4,5.8-1.1 c1.4-0.7,2.5-1.9,3.5-3.6l-6.3-0.6c-0.4,0.5-0.8,0.9-1.1,1.1c-0.6,0.3-1.2,0.5-1.8,0.5c-1,0-1.8-0.4-2.4-1.1 c-0.4-0.5-0.7-1.3-0.8-2.3h12.8L296.8,189.4L296.8,189.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M298,180.3h5.9v2.7c0.9-1.1,1.8-1.9,2.7-2.4c0.9-0.5,2-0.7,3.3-0.7c1.8,0,3.2,0.5,4.2,1.6 c1,1,1.5,2.7,1.5,4.8v10.5h-6.4v-9.1c0-1-0.2-1.8-0.6-2.2c-0.4-0.4-0.9-0.6-1.6-0.6c-0.8,0-1.4,0.3-1.9,0.9 c-0.5,0.6-0.7,1.6-0.7,3.1v8h-6.3L298,180.3L298,180.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M324.2,185.3c0.6-0.7,1.4-1.1,2.3-1.1c0.9,0,1.6,0.4,2.2,1.1c0.6,0.7,0.9,1.8,0.9,3.2c0,1.5-0.3,2.7-0.9,3.4 c-0.6,0.7-1.3,1-2.2,1s-1.7-0.4-2.2-1.1c-0.6-0.7-0.9-1.8-0.9-3.3C323.3,187.1,323.6,186,324.2,185.3z M320,195.2 c1.6,1.3,3.8,2,6.5,2c3,0,5.3-0.8,7-2.4c1.7-1.6,2.5-3.7,2.5-6.3c0-2.3-0.7-4.2-2-5.7c-1.7-1.9-4.2-2.9-7.5-2.9 c-2.9,0-5.2,0.8-6.9,2.5c-1.7,1.6-2.6,3.7-2.6,6.3C316.9,191.3,317.9,193.5,320,195.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M336.3,192.2l6.3-0.6c0.3,0.7,0.6,1.3,1.1,1.6s1.1,0.5,1.9,0.5c0.9,0,1.5-0.2,2-0.5c0.4-0.3,0.5-0.6,0.5-1 c0-0.5-0.2-0.8-0.7-1.1c-0.3-0.2-1.3-0.4-2.7-0.7c-2.2-0.4-3.7-0.7-4.6-1.1c-0.9-0.3-1.6-0.9-2.2-1.7s-0.9-1.7-0.9-2.7 c0-1.1,0.3-2,1-2.8c0.6-0.8,1.5-1.4,2.6-1.8c1.1-0.4,2.6-0.6,4.5-0.6c2,0,3.4,0.2,4.4,0.5c0.9,0.3,1.7,0.8,2.4,1.4 c0.6,0.6,1.2,1.5,1.6,2.6l-6.1,0.6c-0.2-0.5-0.4-0.9-0.8-1.2c-0.5-0.3-1.1-0.5-1.8-0.5s-1.2,0.1-1.6,0.4c-0.3,0.3-0.5,0.6-0.5,0.9 c0,0.4,0.2,0.7,0.6,0.9c0.4,0.2,1.3,0.4,2.7,0.6c2.1,0.2,3.7,0.6,4.7,1s1.8,1,2.4,1.8c0.5,0.8,0.8,1.7,0.8,2.6 c0,1-0.3,1.9-0.9,2.8c-0.6,0.9-1.5,1.6-2.7,2.2c-1.2,0.5-2.9,0.8-5.1,0.8c-3,0-5.2-0.4-6.5-1.3 C337.5,195.1,336.6,193.8,336.3,192.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "CHEDRAUI"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.5,148c0,0-19.5,0-20.6,0c-2.8-0.1-4.9-1.7-4.9-5c0-0.8,0-6.5,0-7.9c0-2.5,1.9-4.5,5.1-4.5 c1.1,0,20.4,0,20.4,0v4.3c0,0-20.4,0-20.7,0c-0.6,0-0.6,0.4-0.6,0.8c0,0.4,0,7.2,0,7.5c0,0.4,0.2,0.5,0.6,0.5c0.4,0,20.6,0,20.6,0 L152.5,148L152.5,148z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "180.1,148 180.1,141.4 163,141.4 163,148 158.8,148 158.8,130.6 163,130.6 163,137.2 180.1,137.2  180.1,130.6 184.4,130.6 184.4,148  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "216.6,143.7 195.2,143.7 195.2,141.5 216.6,141.5 216.6,137.2 195.2,137.2 195.2,134.9 216.6,134.9  216.6,130.6 190.9,130.6 190.9,148 216.6,148  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243.6,130.6c-1.8,0-20.6,0-20.6,0V148c0,0,19.8,0,21.2,0c2.3,0,4.6-1.9,4.6-3.9c0-1.6,0-7.2,0-9 C248.7,132.5,246.1,130.6,243.6,130.6z M244.4,143.7h-17.2v-8.8h17.2V143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.1,134.9c-0.1-2.6-2.4-4.3-4.5-4.3c-1.1,0-21.5,0-21.5,0V148h4.2v-5.1c0,0,16,0,16.6,0s0.8,0.3,0.8,0.9 c0,0.8,0,4.1,0,4.1h4.3c0,0,0-4.3,0-5.1c0-1-0.5-1.8-1-2.2c0.3-0.3,1-1,1-1.8C281.1,138.1,281.1,135.6,281.1,134.9z M276.8,138.7 h-17.5v-3.8h17.5V138.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M303.8,130.7h-6.5L284.2,148h5.3l2.7-3.4h16.7l2.7,3.4h5.3L303.8,130.7z M295.4,140.4l4-5.5h2.2l4,5.5H295.4z "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "351.9,148 351.9,130.6 356.1,130.6 356.1,148  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M324.3,130.6v13.1h17.5v-13.1h4.3c0,0,0,11.6,0,13.1c0,1.9-1.3,4.3-4.6,4.3c-1.7,0-15.7,0-17.2,0 c-2.1,0-4.4-2.3-4.3-4.6c0-0.6,0-12.8,0-12.8H324.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "FAMILY"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "216.2,50.6 229.3,50.6 239.8,61 239.8,74.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "215.8,54.1 215.8,87.9 233.8,87.9 233.8,72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "242.5,60.1 254.9,60.1 278.4,84 265.9,84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "185.9,77.3 198.9,77.3 211.7,90.7 205.4,97.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "242.2,63.5 258.6,80.4 258.6,95.6 230.3,95.6 242.2,83.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "185.7,80.4 185.7,103.4 199.4,103.4 199.4,95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "185.4,105.7 196.8,105.7 177.3,124.5 166.2,124.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "215.6,90.8 231.3,90.8 196.5,124.5 181.2,124.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "214.8,124.5 228.2,124.5 250.3,103.2 271.4,124.5 284.3,124.5 258.6,98 242.2,98  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.3,88.7h4.7c0,0,1.5,7.1,1.9,8.8c0.4,1.7,0.7,3.7,4.1,3.7c2.7,0,24.5,0,24.5,0v14c0,0-13.3,0-20,0 c-5.8,0-10.5-3.6-11.8-10.6C280.8,100,278.3,88.7,278.3,88.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 250.3,
    cy: 48.6,
    rx: 10.2,
    ry: 10.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 193,
    cy: 66,
    rx: 9.6,
    ry: 9.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 272.6,
    cy: 88.6,
    r: 3.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 292.4,
    cy: 88.7,
    rx: 7.1,
    ry: 7.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 292.6,
    cy: 121,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 308.5,
    cy: 121,
    r: 3.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 225,
    cy: 37.7,
    rx: 11,
    ry: 11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M360.7,143.2c-1.3,0-2.5,1-2.5,2.4s1.1,2.4,2.5,2.4c1.3,0,2.4-1,2.4-2.4C363.1,144.3,362,143.2,360.7,143.2z  M360.7,147.7c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S361.8,147.7,360.7,147.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M361.8,145c0-0.5-0.3-0.8-1-0.8h-1.1v2.8h0.4v-1.2h0.5l0.7,1.2h0.5l-0.8-1.2 C361.5,145.8,361.8,145.5,361.8,145z M360.2,145.5v-0.9h0.6c0.3,0,0.6,0.1,0.6,0.4c0,0.4-0.3,0.5-0.7,0.5H360.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChedrauiLogo);
export default __webpack_public_path__ + "static/media/chedraui_logo.fa86cf5b593d06101e171267d33916c3.svg";
export { ForwardRef as ReactComponent };